<template>
  <div class="">
    <v-container fluid>
      <!-- <h1 class="text-lg-center text-md-center text-sm-center earth-color">CURRENT VOLUNTEER PROGRAMS</h1> -->
      
       <h1 class="text-lg-center text-md-center text-sm-center earth-color">CURRENT IMMERSIVE CONSERVATION EXPERIENCE PROGRAM</h1>
      <br>
      <v-layout row wrap v-if="allPrograms !== undefined || allPrograms !== null || allPrograms.length > 0">
        <v-flex lg3 md4 sm6 xs12 v-for="program in allPrograms" :key="program.public_id" v-if="program.image !== null">
          <v-container>
            <v-card flat hover>
              <router-link :to="{name: 'Program', params: {program_id: program.public_id}}">
                <img class="img-responsive" :src="program.image" style="width:100%">
              </router-link>
              <v-container fluid>
                <router-link :to="{name: 'Program', params: {program_id: program.public_id}}"><h5 class="earth-color">{{(program.name).toUpperCase()}}</h5></router-link>
                <br>
                <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px">Price: {{convert1(program.currency, program.price).sign}} {{$roundOff(convert1(program.currency, program.price).amount)}}</h4>
                <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px"><b>Start Date:</b> {{formated_date(program.start_date)}} <br><b>End Date:</b> {{formated_date(program.end_date)}}</h4>
              </v-container>
            </v-card>
          </v-container>
        </v-flex>
      </v-layout>
      <div class="row" v-if="allPrograms === undefined || allPrograms === null || allPrograms.length === 0">
        <div class="col-xs-12 col-md-4">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
        </div>
        <div class="col-xs-12 col-md-4">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
        </div>
        <div class="col-xs-12 col-md-4">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
        </div>
      </div>
    </v-container>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  name: 'programs',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_public_programs')
  }
}
</script>

<style scoped>

</style>
